import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import { anchorsService } from './anchorsService'

export const page: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(anchorsService)
}

export const editorPage = page
